import { ITypedCard, ECardType } from '../types';

export function isHorizontalCard({ type }: ITypedCard): boolean {
  if (type === ECardType.HorizontalFullImage || type === ECardType.HorizontalHalfImage) {
    return true;
  }

  return false;
}
